import { interactionCheckAnswer, postJson } from './medications';

/**
 * POST /interaction-checker — the supplement interaction checker page's check
 * (STACK-587; the route is STACK-586, docs/supplement-interaction-checker.md
 * §3 step 5 and §3.2).
 *
 * The body is exactly the visitor's picks — ingredient RxCUIs and supplement
 * keys from our list — and never a name: the server resolves names from
 * RxNorm itself. Picks travel only in the body, never a URL. A signed-in
 * caller's ID token rides along so the route can tell a member; a visitor
 * sends no auth header.
 *
 * Resolves with the members' response shape plus `isProcessing` on 200 and
 * 202; every refusal (400, 429, 503, other 5xx) throws a GuestRequestError
 * carrying its status and the body's `error` code.
 *
 * @param {number[]} medications - in_rxcui of each picked medication
 * @param {string[]} supplements - supplement keys from our list
 * @param {string|null} idToken - the member's Firebase ID token, or null
 */
export const checkPickedInteractions = async (medications, supplements, idToken = null) => {
  const headers = idToken ? { Authorization: `Bearer ${idToken}` } : {};
  return interactionCheckAnswer(await postJson('/interaction-checker', { medications, supplements }, headers));
};
